'use strict';
const angular = require('angular');

export class datatableComponent {
  constructor() {
    'ngInject';
  }

  $onInit() {
    this.cols = this.columns.split(',');
  }
}

export default angular.module('conduu.datatable-loading-placeholder', [])
  .component('datatableLoadingPlaceholder', {
    template: require('./datatable-loading-placeholder.component.html'),
    bindings: {
      columns: '@'
    },
    controller: datatableComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/datatable-loading-placeholder/datatable-loading-placeholder.component.js